<template>
  <div class="esp-page" :style="{'height' : height,'backgroundColor':bgcolor }">
    <div class="esp-page-floatbtn" :style="style">
      <slot name="floatBtn"></slot>
    </div>
    <div class="white-content" :class="showShandow?'content-shandow':''" :style="{'backgroundColor':bgContentcolor }">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EspPage',
  data() {
    return {}
  },
  methods: {},
  props: {
    height: {
      type: String,
      default: "100%"
    },
    btnTop: { //按钮上定位
      type: String,
      default: "122px"
    },
    btnRight: {
      type: String,
      default: "30px"
    },
    bgcolor: {
      type: String,
      default: "#eff3f1"
    },
    bgContentcolor: {
      type: String,
      default: "#ffffff"
    },
    showShandow: {   //是否显示卡片阴影
      type: Boolean,
      default: true
    }
  },
  computed: {
    style() {
      let style = {};
      style.right = this.btnRight;
      style.top = this.btnTop;
      return style;
    }
  }
}
</script>

<style scoped>
.esp-page {
  padding: 0px 16px 0px 16px;
  /*padding: 0px 8px 8px 8px;*/
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  display: flex;
  -webkit-box-flex: 1;
  flex: 1;
  flex-basis: auto;
  box-sizing: border-box;
  min-width: 0;
  /*background: #eee;*/
  width: 100%;
}

.esp-page-floatbtn {
  position: fixed;
  right: 30px;
  top: 122px;
  z-index: 99999;
}

.white-content {
  height: 100%;
  border-radius: 4px;
  /*background-color: #ffffff;*/
}

.content-shandow {
  box-shadow: 0 0 3px rgba(0, 0, 0, .13);
}
</style>




// WEBPACK FOOTER //
// src/components/layout/EspPage.vue